var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-background-hero-section',{staticClass:"basic-background-hero-section-module",attrs:{"title":_vm.attributes.basicBackgroundHero_title,"background-image":_vm.backgroundImage}})}
var staticRenderFns = []

export { render, staticRenderFns }